import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Delete from "../../common/delete";
import Edit from "../../common/edit";
import MatTable from "../../common/matTable";

const UsersTable = ({ data, sortColumn, onSort, onDelete }) => {
  const { t } = useTranslation(["userManagement"]);
  const columns = [
    { path: "id", label: t("ID") },
    {
      path: "firstName",
      label: t("Name"),
      content: (item) => {
        return <Link to={`/user-management/${item.id}`}>{item.firstName}</Link>;
      },
      sort: true,
    },
    { path: "email", label: t("Email"), sort: true },
    { path: "mobile", label: t("Mobile") },
    { path: "login", label: t("Login") },
    { path: "activated", label: t("Activated"), 
    content: (item) => {
      return item.activated?"Yes":"No";
    },},
    {
      path:"instituteTenant",label:t("Institute")
    },
    {
      key: "action",
      content: (item) => {
        return <Edit link={`/user-management/${item.id}`}/>;
      },
    },
    {
      key: "delete",
      content: (item) => <Delete onDelete={onDelete} item={item} />,
    },
  ];

  return (
    <MatTable
      data={data}
      columns={columns}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default UsersTable;
